export default "__VITE_ASSET__DQfJOpXa__"